<template>
  <pop-up-layout
    :title="!editar ? localization.titleCrear : localization.titleEditar + ' ' + item.uhedit"
    :description="localization.subtitle"
    :loading="loading"
    :saving="waitingForLoad"
    aceptar="Aceptar"
    @volver="cerrarPopup()"
    @aceptar="enviarInmueble()"
  >
    
    <Alerts></Alerts>
    <v-form v-model="valid" id="valid" ref="formInmuebles" autocomplete="off">
      <v-col cols="12" :style="seleccionarPromociones === true ? 'display: none;' : ''"><!-- :style="seleccionarPromociones ? 'display: hidden' : ''" -->
        <v-row class="pl-6">
          <v-col cols="4" md="4">
            <div @click="abrirPromociones()" >    
              <v-autocomplete
                :rules="[rules.required]"
                v-model="promoSelected" 
                id="promoSelected"
                :items="promociones"
                item-value="id"
                item-text="nombreCompleto"
                readonly
                @click="abrirPromociones()"
                :label="localization.promociones"
                :disabled="editar ? true : false"
              />
            </div>
          </v-col>
          <v-col cols="4" md="4">
            <v-autocomplete
              :rules="[rules.obligatorio]" 
              v-model="propertyTypeSelectedId" 
              id="propertyTypeSelectedId" 
              :items="propertyTypes" 
              item-text="name"
              item-value="id" 
              :label="localization.camposInmueble.tipoInmueble"
            >
              <template v-slot:selection="data">
                {{ data.item.code }} - {{ data.item.name }}
              </template>
              <template v-slot:item="data">
                {{ data.item.code }} - {{ data.item.name }}
              </template> 
            </v-autocomplete>
          </v-col>
          
  
          <v-col cols="12" pl-6>
            <v-row>
              <h2 class="primary--text text-uppercase" style="font-size: 18px">
                Datos del inmueble
              </h2>
            </v-row>
            <v-row style="padding-left:0px">
              <v-col cols="12" style="padding-left:0px">
                <v-divider class="divider_subtitle" style="padding-left:0px"></v-divider>
              </v-col>
            </v-row>
          </v-col>
         
          <v-col cols="2" md="2">
            <v-text-field
              :rules="[rules.max(5)]"
              v-model="clave1" 
              id="clave1"
              :label="localization.camposInmueble.clave1"
              :value="selectedPropertyType ? selectedPropertyType.code : '' "    
              />
          </v-col>
          <v-col cols="2" md="2"> 
            <v-text-field
              :rules="[rules.max(5)]"
              :label="localization.camposInmueble.clave2"
              v-model="clave2" 
              id="clave2"  
            />
          </v-col>
          <v-col cols="2" md="2">
            <v-text-field 
              :rules="[rules.max(5)]"
              :label="localization.camposInmueble.clave3"
              v-model="clave3" 
              id="clave3"  
            />
          </v-col>
          <v-col cols="2" md="2">   
            <v-text-field 
              :rules="[rules.max(5)]"
              :label="localization.camposInmueble.clave4"
              v-model="clave4" 
              id="clave4"  
            />
          </v-col>
          <v-col cols="2" md="2">  
            <v-text-field 
              :rules="[rules.max(5)]"
              :label="localization.camposInmueble.clave5"
              v-model="clave5" 
              id="clave5"  
            />
          </v-col>
  
          <v-col cols="12" pl-6>
            <v-row>
              <h2 class="primary--text text-uppercase" style="font-size: 18px">
                Identificadores del inmueble
              </h2>
            </v-row>
            <v-row style="padding-left:0px">
              <v-col cols="12" style="padding-left:0px">
                <v-divider class="divider_subtitle" style="padding-left:0px"></v-divider>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="4" md="4">
            <v-text-field 
              :label="localization.camposInmueble.unhedit"
              v-model="uhedit" 
              id="uhedit" 
              readonly
              disabled
            />
          </v-col>
          <v-col cols="8" md="8">  
            <v-row>
            <v-text-field
            @keydown="aliasCambiado()"
              :rules="[rules.obligatorio, rules.max(100)]"
              :label="localization.camposInmueble.alias"
              ref="alias"
              v-model="alias" 
              id="alias"
            />
            <!-- v-model="alias" id="alias" -->
            <v-btn icon @click="logAlias()" class="mt-4">
                    <v-icon  color="primary">mdi-refresh</v-icon>
            </v-btn></v-row>
          </v-col>
          <v-col cols="4" md="4">
            <v-text-field 
              v-model="codigo" 
              id="codigo"
              :rules="[rules.obligatorio, rules.max(250)]"
              :label="localization.camposInmueble.codigo"
              maxlength="10"
            />
          </v-col>
          <v-col cols="8" md="8">  
            <v-text-field 
              :label="localization.camposInmueble.descripcion"
              :rules="[rules.obligatorio, rules.max(100)]"
              v-model="descripcion" 
              id="descripcion"
            />
          </v-col>
          <v-col cols="12" pl-6>
            <v-row>
              <h2 class="primary--text text-uppercase" style="font-size: 18px">
                Ubicación
              </h2>
            </v-row>
            <v-row style="padding-left:0px">
              <v-col cols="12" style="padding-left:0px">
                <v-divider class="divider_subtitle" style="padding-left:0px"></v-divider>
              </v-col>
            </v-row>
          </v-col>  
          <v-col cols="9" md="9">
            <v-text-field
              :label="localization.camposInmueble.direccion"
              v-model="direccion" 
              id="direccion"
              :rules="[rules.max(250)]"
            />
          </v-col>
          <v-col cols="3" md="3">
            <v-text-field
              :rules="[rules.max(10)]" 
              :label="localization.camposInmueble.codigoPostal"
              v-model="codigoPostal" 
              id="codigoPostal"
            />
          </v-col>
          <v-col cols="4" md="4">
            <v-text-field 
              :label="localization.camposInmueble.poblacion"
              v-model="poblacion" 
              id="poblacion"
              :rules="[rules.max(100)]" 
            />
          </v-col>
          <v-col cols="4" md="4">
            <v-text-field 
              :label="localization.camposInmueble.provincia"
              v-model="provincia" 
              id="provincia"
              :rules="[rules.max(100)]"
            />
          </v-col>
          <v-col cols="4" md="4">
            <v-text-field 
              :label="localization.camposInmueble.pais"
              v-model="pais" 
              id="pais"
              :rules="[rules.max(100)]"
            />
          </v-col>
        </v-row>
        <o-file-uploader
          v-model="files" 
          id="files"
          :titulo="'Añadir plano'"
          :icon="'photo'"
          :maxNum="1"
          :imagesOnly="true"
          @input="cambiarFoto()"
        />        
      </v-col>
    </v-form>
    <custom-dialog 
        v-if="seleccionarPromociones === true" 
        :sinBackground="true"
        v-model="seleccionarPromociones" 
        id="seleccionarPromociones"
      >
        <PopUpSeleccionarAllPromociones @selected="promoSelected = $event" :yaSeleccionado="promoSelected != null ? [promoSelected] : []"/>
    </custom-dialog>
  </pop-up-layout>
</template>

<script>
import { mapActions } from 'vuex'
import rulesMixin from '@/components/generic/rules.js'
import Alerts from '@/components/Alerts'
import PopUpSeleccionarAllPromociones from './PopUpSeleccionarAllPromociones.vue'
export default {
  components: {
    Alerts,
    PopUpSeleccionarAllPromociones
  },
  mixins: [rulesMixin],
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    editar: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      valid: false,
      waitingForLoad: false,
      loading: false,
      propertyTypeSelectedId: null,
      promoSelected: null,
      codigo: null,
      clave1: null,
      clave2: null,
      clave3: null,
      clave4: null,
      clave5: null,
      alias: null,
      descripcion: null, 
      direccion: null,
      codigoPostal: null,
      poblacion: null,
      pais: null, 
      provincia: null,
      valorCP: null,
      seleccionarPromociones: false,
      refrescarAlias: false,
      cambiado: null,
      cambiadoEditar: null,
      files: [],
      fotoCambiada: false
    }
  },
  async created () {
    if(this.editar === true)
    { this.loading = true
      this.cambiadoEditar = true
      if(this.item.alias != this.aliasDefault)
      {
        this.refrescarAlias = true
        
      }
      await this.getPromociones()
      let datosImg = {
        code: this.item.code,
        id: this.item.id
      }
      await this.getImageByProperty(datosImg)
      this.codigo = this.item.code
      this.clave1 = this.item.clave1
      this.clave2 = this.item.clave2
      this.clave3 = this.item.clave3
      this.clave4 = this.item.clave4
      this.clave5 = this.item.clave5
      this.alias = this.item.alias
      this.descripcion = this.item.name
      this.direccion = this.item.direccion
      this.codigoPostal = this.item.codigoPostal
      this.poblacion = this.item.poblacion
      this.pais = this.item.pais
      this.provincia = this.item.provincia
      this.propertyTypeSelectedId = this.item.tipoInmuebleId
      this.promoSelected = this.promociones.find(x => x.id === this.item.promocionId) != null ? this.promociones.find(x => x.id === this.item.promocionId) : []
      if(this.imagenesProperty.length != 0)
      {
        let values = {
        documentoGrande: this.imagenesProperty[0].documentoMiniatura, 
        nombre: this.imagenesProperty[0].nombre,
        mime: this.imagenesProperty[0].mime,
        id: this.imagenesProperty[0].id,
        tamanio: 10
      }
      this.files.push(values) 
    } 
      
      this.loading = false
    }else{
      this.loading = true
      await this.getPromociones()
      /* this.promoSelected = this.promociones.find(x => x.id === this.item.promocionId) != [] && this.item != {} ? this.promociones.find(x => x.id === this.item.promocionId) : null */
      this.promoSelected = this.item.promocionId != null ? this.promociones.find(x => x.id === this.item.promocionId) : []
      this.loading = false
    }
  },
  computed: {
    localization () {
      return this.$t('popUpCrearInmueble')
    },
    headers () {
      return [
        {text: this.localization.headerCodigo, value: 'nombreCompleto', sortable: true, align: 'LEFT'},
        {text: this.localization.headerRegion, sortable: false, align: 'LEFT'}, 
        {text: this.localization.headerSector, sortable: false, align: 'LEFT'}
      ]
    },
    propertyTypes () {
      if (this.$store.state.incidencias.propertyTypes) {
        return this.$store.state.incidencias.propertyTypes.map(x => {
          return {
            ...x,
            nombreCompleto: x.code + ' - ' + x.name
          }
        })
      }
      return []
    },
    selectedPropertyType()
    {
      let obj = this.propertyTypes.filter(x => x.id === this.propertyTypeSelectedId)
      return obj[0]
    },
    promociones() {
      if (this.$store.state.gestion.promotions) {
        return this.$store.state.gestion.promotions.map(x => {
          return {
            ...x,
            nombreCompleto: x.code + ' - ' + x.name
          }
        })
      }
      return []
    },
    inmueble(){
      const value = {
      code: this.codigo, 
      clave1: this.clave1, 
      clave2: this.clave2, 
      clave3: this.clave3, 
      clave4: this.clave4, 
      clave5: this.clave5, 
      alias: this.alias,
      uhedit: this.uhedit,
      name: this.descripcion,
      direccion: this.direccion, 
      codigoPostal: this.codigoPostal, 
      poblacion: this.poblacion, 
      pais: this.pais,
      provincia: this.provincia, 
      /* valorCP: this.valorCP,  */
      tipoInmuebleId: this.propertyTypeSelectedId, 
      promocionId: this.promoSelected != null ? this.promoSelected.id : null,
      files: this.files,
      fotoCambiada: this.fotoCambiada,
      fileId: this.editar === true && this.fotoCambiada === true && this.imagenesProperty.length != 0 ? this.imagenesProperty[0].id : null
      }
      return value
    },
    imagenesProperty(){
      if (this.$store.state.gestion.imageByProperty) {
        
        return this.$store.state.gestion.imageByProperty
      }
      return []
    },
    alertClaves(){
      if(this.clave1 == null && this.clave2 == null && this.clave3 == null && this.clave4 == null && this.clave5 == null)
      return true
      else
      return false
    },
    uhedit(){
      if(this.selectedPropertyType){
      return this.selectedPropertyType.code + (this.clave1 ? '-' + this.clave1 : '') 
        + (this.clave2 ? '-' + this.clave2 : '')
        + (this.clave3 ? '-' + this.clave3 : '')
        + (this.clave4 ? '-' + this.clave4 : '') 
        + (this.clave5 ? '-' + this.clave5 : '') } else {return (this.clave1 ? '-' + this.clave1 : '') 
        + (this.clave2 ? '-' + this.clave2 : '')
        + (this.clave3 ? '-' + this.clave3 : '')
        + (this.clave4 ? '-' + this.clave4 : '') 
        + (this.clave5 ? '-' + this.clave5 : '')}
    },
    
    aliasDefault(){
      let aliasDefecto = (this.selectedPropertyType ? this.selectedPropertyType.name : '') + (this.clave1 ? ' Bloque ' + this.clave1 : '') 
        + (this.clave2 ? ' Portal ' + this.clave2 : '')
        + (this.clave3 ? ' Escalera ' + this.clave3 : '')
        + (this.clave4 ? ' Planta ' + this.clave4 : '') 
        + (this.clave5 ? ' Puerta ' + this.clave5 : '') 
        return aliasDefecto
    },
  },
   mounted () {
    this.getPromociones()
    this.getPropertyTypes()
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      getPromociones: 'gestion/getPromotions',
      getPropertyTypes: 'incidencias/getPropertyTypes',
      getImageByProperty: 'gestion/getImageByProperty'
    }),
    cambiarFoto(){
      if(this.editar === true)
      {
        this.fotoCambiada = true
      }
    },
    logAlias(){
      this.cambiado = false
      this.cambiadoEditar = false
      this.alias = this.aliasDefault
    },
    aliasCambiado(){
      this.cambiado = true
      if(this.editar){this.cambiadoEditar = true}
      
    },
    
    cerrarPopup() {
      this.$parent.hide()
      this.$parent.$parent.sheet = true
    },
    enviarInmueble(){
      this.$refs.formInmuebles.validate()
      if(!this.valid){
        this.addAlert({texto: 'Por favor, revise los campos marcados en rojo', color: 'error'})
      } else {
        if(this.alertClaves === true)
        {
          this.addAlert({texto: 'Por favor, añada al menos un dato del inmueble', color: 'error'})
        }else{
          this.$emit('aceptar', this.inmueble)
          this.cerrarPopup()
        }
        
      }
      
    },
    abrirPromociones() {
      if(!this.editar){this.seleccionarPromociones = true}
      
    }
  },
  watch:{
    aliasDefault()
    {
      console.log('entro el alias')
      if(!this.cambiado && !this.cambiadoEditar){
        this.alias = this.aliasDefault
      }
      else {return }
    },
    /* files(){
      if(this.files.length === 0)
      {
        this.fotoCambiada = true
      }
    } */
  } 
  
}
</script>

<style scoped>
  .info-tooltip {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.54);
    font-weight: bold;
    margin-bottom: 0px;
  }
</style>